import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'theme';

function getInitialDark() {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'dark') return true;
  if (stored === 'light') return false;
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

function applyClass(isDark) {
  const root = document.documentElement;
  root.classList.toggle('dark', isDark);
  root.classList.toggle('light', !isDark);
  const color = isDark ? '#020204' : '#fdfcfe';
  document.querySelectorAll('meta[name="theme-color"]').forEach((meta) => {
    meta.setAttribute('content', color);
  });
  root.dispatchEvent(new CustomEvent('themechange', { detail: { isDark } }));
}

export default function useTheme() {
  const [isDark, setIsDark] = useState(getInitialDark);

  // Apply class whenever isDark changes
  useEffect(() => {
    applyClass(isDark);
  }, [isDark]);

  // Listen for OS preference changes — only apply when no localStorage override
  useEffect(() => {
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e) => {
      if (!localStorage.getItem(STORAGE_KEY)) {
        setIsDark(e.matches);
      }
    };
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const toggleTheme = useCallback(() => {
    setIsDark((prev) => {
      const next = !prev;
      localStorage.setItem(STORAGE_KEY, next ? 'dark' : 'light');
      return next;
    });
  }, []);

  return { isDark, toggleTheme };
}
